import React, { ReactNode } from 'react';

interface BodyProps {
	children: ReactNode;
}

export const Body = ({ children }: BodyProps) => {
	return (
		<div className="flex flex-col justify-center p-5 bg-tablz-dark-gray-1 text-center gap-8 text-tablz-text-gray-1 font-poppins text-base font-normal leading-6 [&_strong]:text-white [&_strong]:font-normal">{children}</div>
	);
};
